module.exports = {
      id: "money-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#money-icon",
      toString: function () {
        return this.url;
      }
    }